export default __webpack_public_path__ + "static/media/happy.d1b4ba8f.png";